import { FC, ReactElement } from 'react'

import { ListGroupItem } from '@/components'
import { convertDateToDateString, convertDateToDay, convertDateToTime } from '@/helpers/DateTimeParser'
import { PreferToWorkTimeSlotResource } from '@/models'

interface PlanningPreferenceItemProps {
    preference: PreferToWorkTimeSlotResource
    onClick?: () => void
    className?: string
}

export const PlanningPreferenceItem: FC<PlanningPreferenceItemProps> = ({ preference, onClick = () => {}, className = '' }): ReactElement => {
    const time = `${convertDateToTime(preference.start)} - ${convertDateToTime(preference.end)}`

    return (
        <ListGroupItem onClick={onClick} className={className}>
            <div className="list-group-item__header text">
                <div className="d-flex flex-row">
                    <div className="font-weight-bold">{convertDateToDay(preference.start)}</div>
                    <div className="text text-nowrap ml-1"> {`- ${convertDateToDateString(preference.start)}`}</div>
                </div>
                <div>{time}</div>
                <div>
                    { preference.comment }
                </div>
            </div>
        </ListGroupItem>
    )
}
